var map = {
	"./features/about/about.module": [
		"./src/app/features/about/about.module.ts",
		"features-about-about-module"
	],
	"./features/home2/home2.module": [
		"./src/app/features/home2/home2.module.ts",
		"features-home2-home2-module"
	],
	"./features/subscribe/subscribe.module": [
		"./src/app/features/subscribe/subscribe.module.ts",
		"features-subscribe-subscribe-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;